<template>
  <div class="dateSingleOrRange">
    <RadioTop :options="['今日', '單日', '期間']" :defaultValue="type" @input="type=$event" @same="show=type!=='今日'"/>
    <div class="pop" v-show="type!=='今日'&&show">
      <DateInput v-if="type==='單日'" :style="{height: '40px'}"
      :defaultValue="range.start" @input="range.start=$event;range.end=$event;show=false"/>
      <DateRange v-else-if="type==='期間'" :style="{height: '40px'}"
      :defaultValue="range" @input="range=$event"/>
    </div>
  </div>
</template>

<script>
import DateInput from '../input/date.vue'
import DateRange from '../input/dateRange.vue'
import RadioTop from './r1.vue'
export default {
  props: ['defaultValue'],
  name: 'dateSingleOrRange',
  components: {
    RadioTop,
    DateInput,
    DateRange
  },
  data () {
    return {
      show: false,
      type: '今日',
      range: {
        start: this.moment().format('yyyy-MM-DD'),
        end: this.moment().format('yyyy-MM-DD')
      }
    }
  },
  mounted () {
  },
  watch: {
    range: {
      deep: true,
      handler () {
        if (this.defaultValue.start === this.range.start && this.defaultValue.duration === this.range.duration && this.defaultValue.end === this.range.end) {
        } else if (this.range.start && this.range.end) {
          this.range.duration = this.moment(this.range.end).diff(this.moment(this.range.start), 'day')
          this.$emit('input', this.range)
          this.show = false
        }
      }
    },
    defaultValue: {
      handler () {
        console.log('defalutChanged start', this.defaultValue)
        if (this.defaultValue.start === this.range.start && this.defaultValue.duration === this.range.duration && this.defaultValue.end === this.range.end) {
        } else if ((this.defaultValue.start === null || this.defaultValue.start === this.moment().format('yyyy-MM-DD')) && this.defaultValue.duration === 0) {
          console.log('defalutChanged 今日', this.defaultValue.start, this.defaultValue.duration)
          const today = this.moment().format('yyyy-MM-DD')
          this.type = '今日'
          this.range = {
            duration: 0,
            start: today,
            end: today
          }
        } else if (this.defaultValue.start !== this.moment().format('yyyy-MM-DD') && this.defaultValue.duration === 0) {
          console.log('defalutChanged 單日', this.defaultValue.start, this.defaultValue.duration)
          this.type = '單日'
          this.range = {
            duration: 0,
            start: this.defaultValue.start,
            end: this.defaultValue.end
          }
        } else {
          console.log('defalutChanged 期間', this.defaultValue.start, this.defaultValue.duration)
          this.type = '期間'
          this.range = {
            duration: this.moment(this.defaultValue.end).diff(this.moment(this.defaultValue.start), 'day'),
            start: this.defaultValue.start,
            end: this.defaultValue.end
          }
        }
      },
      immediate: true,
      deep: true
    },
    type () {
      if (this.type === '今日') {
        this.$emit('input', {
          duration: 0,
          start: this.moment().format('yyyy-MM-DD'),
          end: this.moment().format('yyyy-MM-DD')
        })
      } else {
        this.show = true
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.dateSingleOrRange {
#setDate-wrapper #setDate-input {
  border-color: #C4C4C4;
}
  #setDateRange-wrapper #setDateRange-input {
    height: 40px;
    letter-spacing: 0;
  }
  #setDateRange-wrapper {
    width: 300px;
  }
}
</style>
<style lang="scss" scoped>
.dateSingleOrRange {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 14px;
  position: relative;
}
.pop {
  position: absolute;
  top: 42px;
  height: 60px;
  right: 0;
  padding: 10px;
  background: #FFFFFF;
  box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.25), -2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  display: flex;
  align-items: center;
}
</style>
